/* Lieferdatum für Produkt- und Startseite: eine gemeinsame Quelle (pb-pdp.js und eh-home.js nutzen window.EaEta).
   Versand: Bestellungen Mo–Fr gehen innerhalb von 24 h raus; am Wochenende oder Feiertag am nächsten Werktag.
   Lieferung: 6–10 Werktage ab dem Tag nach der Bestellung, nur Mo–Fr, ohne bundesweite Feiertage, deutsche Zeit. */
(function () {
  /* eta:start – Zustelldatum fuer die Liefer-Zeitachse.
     Gezaehlt werden Werktage ab dem Tag nach der Bestellung: nur Mo–Fr, ohne bundesweite Feiertage,
     immer in deutscher Zeit (Europe/Berlin), egal wo der Besucher ist. Gerechnet wird in UTC-Tagen,
     damit Sommer-/Winterzeit keinen Tag verschiebt. */
  var ETA_DAY = 864e5;
  var ETA_MONTHS = ['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sept.', 'Okt.', 'Nov.', 'Dez.'];
  var etaHolidayCache = {};
  function etaBerlinNow(now) {
    try {
      var p = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Berlin', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23' })
        .formatToParts(now).forEach(function (x) { p[x.type] = parseInt(x.value, 10); });
      if (p.year && p.month && p.day) return [p.year, p.month - 1, p.day, (p.hour || 0) % 24];
    } catch (e) { /* aeltere Browser: Geraetezeit */ }
    return [now.getFullYear(), now.getMonth(), now.getDate(), now.getHours()];
  }
  function etaEaster(y) {
    /* Gausssche Osterformel (gregorianisch, anonymer Algorithmus) */
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
    var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    var n = h + l - 7 * m + 114;
    return Date.UTC(y, Math.floor(n / 31) - 1, (n % 31) + 1);
  }
  function etaHolidays(y) {
    if (etaHolidayCache[y]) return etaHolidayCache[y];
    var easter = etaEaster(y), list = {};
    [
      Date.UTC(y, 0, 1),            /* Neujahr */
      easter - 2 * ETA_DAY,         /* Karfreitag */
      easter + ETA_DAY,             /* Ostermontag */
      Date.UTC(y, 4, 1),            /* Tag der Arbeit */
      easter + 39 * ETA_DAY,        /* Christi Himmelfahrt */
      easter + 50 * ETA_DAY,        /* Pfingstmontag */
      Date.UTC(y, 9, 3),            /* Tag der Deutschen Einheit */
      Date.UTC(y, 11, 25),          /* 1. Weihnachtstag */
      Date.UTC(y, 11, 26)           /* 2. Weihnachtstag */
    ].forEach(function (t) { list[t] = true; });
    etaHolidayCache[y] = list;
    return list;
  }
  function etaIsWorkday(t) {
    var d = new Date(t), wd = d.getUTCDay();
    return wd !== 0 && wd !== 6 && !etaHolidays(d.getUTCFullYear())[t];
  }
  function etaRange(now, min, max, cutoff) {
    var b = etaBerlinNow(now), t = Date.UTC(b[0], b[1], b[2]), n = 0, from = 0;
    /* Bestellschluss gilt nur an Werktagen; am Wochenende/Feiertag geht der Versand ohnehin erst am nächsten Werktag. */
    if (cutoff > 0 && b[3] >= cutoff && etaIsWorkday(t)) t += ETA_DAY;
    while (n < max) {
      t += ETA_DAY;
      if (etaIsWorkday(t)) { n++; if (n === min) from = t; }
    }
    return [new Date(from), new Date(t)];
  }
  function etaLabel(a, b) {
    var am = a.getUTCMonth(), bm = b.getUTCMonth();
    if (a.getTime() === b.getTime()) return b.getUTCDate() + '. ' + ETA_MONTHS[bm];
    if (am === bm && a.getUTCFullYear() === b.getUTCFullYear()) return a.getUTCDate() + '.–' + b.getUTCDate() + '. ' + ETA_MONTHS[bm];
    return a.getUTCDate() + '. ' + ETA_MONTHS[am] + ' – ' + b.getUTCDate() + '. ' + ETA_MONTHS[bm];
  }
  var ETA_WEEKDAYS = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
  /* Versandtag: null, wenn der Versand innerhalb von 24 h erfolgt (Werktag, ggf. vor Bestellschluss oder
     nächster Werktag ist morgen); sonst der nächste Werktag als Datum (Wochenende, Feiertag, Freitag nach Schluss). */
  function etaShipDay(now, cutoff) {
    var b = etaBerlinNow(now), today = Date.UTC(b[0], b[1], b[2]), t = today;
    if (etaIsWorkday(today) && !(cutoff > 0 && b[3] >= cutoff)) return null;
    do { t += ETA_DAY; } while (!etaIsWorkday(t));
    if (etaIsWorkday(today) && t === today + ETA_DAY) return null;
    return new Date(t);
  }
  function etaShipLabel(d) { return 'Am ' + ETA_WEEKDAYS[d.getUTCDay()]; }
  /* eta:end */

  window.EaEta = { range: etaRange, label: etaLabel, shipDay: etaShipDay, shipLabel: etaShipLabel };
})();
